import { useState, useEffect } from 'react';

import { useValidateSession } from './useValidateSession'
import { decodeStorage } from './storageBase64';
import { useToken } from './useToken';

export function useInterceptor(){

    const [serviceRT, setServiceRT] = useState(false)
    const [uD, setUD] = useState(false)

    /*  --------------------------- Inicio --------------------------------------  */
    //  Hooks para validar tiempo y refresh token mas state de boton
    const { session } = useValidateSession()
    const {refreshCyR , errorToken} = useToken({firstActive: false})
    const [actionOK, setActionOk] = useState(false)
    /*  --------------------------- Fin --------------------------------------  */

    //  funcion que Ajusta Los tiempos y refresca token
    const validateLiveToken = () => {
        let  actTimeLS = Date.now() 
        let  atExpLS = decodeStorage('access_token_exp') * 1000
        let time = decodeStorage("access_token")
        let timeToken
        if(time){
            timeToken = JSON.parse( window.atob( time?.split('.')[1] ) )
        }
        setUD(false)

        // console.log('------------------------------')
        // console.log('session : ', session )
        // console.log('access_token : ', time )
        // console.log('timeToken : ', timeToken )
        // console.log('actTimeLS m : ', ( new Date( Date.now() + 180000) ) )
        // console.log('actTimeLS   : ', new Date() )
        // console.log('atExp   : ', new Date (atExpLS) )
        // console.log('time ok : ', actTimeLS <= atExpLS)
        // console.log('actionOK: ', actionOK)
        // console.log('------------------------------')
        
        if(actTimeLS <= atExpLS || Date.now() <= decodeStorage('access_token_exp') * 1000 ){
            if(session && time){
                if( Date.now() >= (timeToken?.iat * 1000) ){
                    setServiceRT(true)
                }else{
                    let tiempo = Math.floor( (timeToken?.iat * 1000) - Date.now() ) + 1000
                    console.log('preTime: ', tiempo)
                    setTimeout(function(){
                        setServiceRT(true)
                    },tiempo)
                }
            }
        }
        else{
            setTimeout(function(){
                if(session && time){
                    // console.log('refreshCyR')
                    refreshCyR.forceToken(true)
                    setServiceRT(false)
                }
            },300)
            setTimeout(function(){
                // console.log('setUD true')
                setUD(true)
                setServiceRT(false)
            },900)
        }
    }

    //  Aefecto detona el refresh si lo requiere
    useEffect(() => {
        if(session){
            if(actionOK){
                // console.log('actionOK: ', actionOK)
                setTimeout(() => {
                    // console.log('errorToken: ', errorToken)
                    if(!errorToken){
                        validateLiveToken()
                    }
                }, 2300)
            }
        }
    }, [uD, actionOK])


    return {
        setActionOk,
        setServiceRT,
        actionOK,
        serviceRT
    }
}